import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import useWaitlistForm from '../hooks/useWaitlistForm';

export default function WaitlistForm() {
  const { fields, setField, status, handleSubmit } = useWaitlistForm();

  if (status === 'success') {
    return (
      <div className="waitlist-success">
        <FiCheckCircle size={16} style={{ flexShrink: 0, marginTop: 2 }} />
        <span>
          You're on the list{fields.name ? `, ${fields.name}` : ''}. We'll
          be in touch before launch.
        </span>
      </div>
    );
  }

  return (
    <form className="waitlist-form" onSubmit={handleSubmit} noValidate>
      <div className="wf-row">
        <div className="wf-field">
          <label className="wf-label" htmlFor="wf-name">Name</label>
          <input
            id="wf-name"
            className="wf-input"
            type="text"
            placeholder="Your name"
            value={fields.name}
            onChange={setField('name')}
            autoComplete="name"
            required
          />
        </div>
        <div className="wf-field">
          <label className="wf-label" htmlFor="wf-email">Email</label>
          <input
            id="wf-email"
            className="wf-input"
            type="email"
            placeholder="Work email"
            value={fields.email}
            onChange={setField('email')}
            autoComplete="email"
            required
          />
        </div>
      </div>

      <div className="wf-field">
        <label className="wf-label" htmlFor="wf-usecase">Use Case</label>
        <textarea
          id="wf-usecase"
          className="wf-textarea"
          placeholder="What will you use Pramaan for? e.g. vendor contracts, employee onboarding, client NDAs…"
          value={fields.useCase}
          onChange={setField('useCase')}
          rows={3}
          required
        />
      </div>

      {status === 'error' && (
        <p className="wf-error">Please fill in all fields with a valid email.</p>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
        <button className="wf-btn" type="submit" disabled={status === 'loading'}>
          {status === 'loading' ? 'Submitting…' : 'Request Early Access'}
        </button>
        <p className="wf-privacy">No spam. Launch updates only.</p>
      </div>
    </form>
  );
}
